<!--
 * @Author: your name
 * @Date: 2021-08-07 16:49:04
 * @LastEditTime: 2021-08-31 17:41:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\pages\exclusivePurchase\basePurchase.vue
-->
<template>
<div>
    
      <div class="exclusive-top">
          <p><span>提示：</span>欢迎您使用采购专属商城，为方便贵企业开展采购业务，您需要完成以下几个步骤。</p>
      </div>
      <el-card class="box-card my-box-card ">
        <div class="box-card-content">
          <div class="box-card-title flex-sb">
            <p class="title">1.企业基础配置</p>
            <p>
              <i class="icon-circle" v-if="typeObj.check1==1"></i>
              <i class="el-icon-circle-check icon-success" v-if="typeObj.check1==2"></i>
              <i class="el-icon-circle-close icon-error" v-if="typeObj.check1==3"></i>
            </p>
          </div>
          <div class="box-card-desc">
            在这里，您需要维护贵企业的<span @click="toPath('/institutionManage')">组织机构</span>信息，并添加贵企业<span @click="toPath('/userManage')">员工用户</span>。
          </div>
        </div>
      </el-card>
      <el-card class="box-card  my-box-card">
        <div class="box-card-content">
          <div class="box-card-title flex-sb">
            <p class="title">2.采购权限配置</p>
            <p>
              <i class="icon-circle" v-if="typeObj.check2==1"></i>
              <i class="el-icon-circle-check icon-success" v-if="typeObj.check2==2"></i>
              <i class="el-icon-circle-close icon-error" v-if="typeObj.check2==3"></i>
            </p>
          </div>
          <div class="box-card-desc">
            在这里，您需要维护贵企业开展采购业务所需的<span @click="toPath('/roleManage')">角色权限</span>，设置相应的人员岗位。
          </div>
        </div>
      </el-card>
       <el-card class="box-card  my-box-card">
        <div class="box-card-content">
          <div class="box-card-title flex-sb">
            <p class="title">3.自有采购框架协议设置</p>
            <p>
              <i class="icon-circle" v-if="check3==1"></i>
              <i class="el-icon-circle-check icon-success" v-if="check3==2"></i>
              <i class="el-icon-circle-close icon-error" v-if="check3==3"></i>
            </p>
          </div>
          <div class="box-card-desc">
            在这里，您可以维护贵企业的<span @click="toPath('/agreementManage')">采购框架协议</span>，由贵企业的供应商维护协议商品后，您可在采购专属商城看到这些商品。
          </div>
        </div>
      </el-card>
</div>
     
</template>

<script>
import agreementApi from '../../api/agreement/index'

export default {
  props:{
      typeObj: {
          type: Object,
      },
  },
   data(){
       return {
            check3:1,
       
       }
   },
   created(){
      // this.queryEpecPriceIsExist()
   },
   computed:{
    ea_userInfo() {
      return this.$store.state.USERINFO
    },
  },
  watch:{
     ea_userInfo:{
      immediate:true,
      handler(val){
        if(val.companyId){
          this.queryEpecPriceIsExist()
        }
      },
      deep:true
    }
  },
   methods:{
      async queryEpecPriceIsExist(){
        let res =await agreementApi.queryEpecPriceIsExist();
        if(res.code==200){
          if(res.data==1){
            this.check3=2
          }else{
            this.check3=3
          }
        }
      },
      toPath(path){
        this.$router.push(path)
      }
      
   }
}
</script>

<style lang="scss" scoped>

@import "@/assets/css/tip";
.exclusive-top{
  width: 100%;
  height:44px;
  line-height: 44px;
  background:#E8EFFF;
  box-sizing: border-box;
  padding: 0 20px;
  margin: 10px 0 20px;
  p{
    font-size: 16px;
    color: #333;
    span{
      color: #EF4C56;
      font-weight: bold;
    }
  }
}
.my-box-card{
  // height: 90px;
}
.box-card-desc{
      
      span:hover{
        // text-decoration: underline;
      }
    }

</style>
